<template lang="pug">
.overlap-wrapper
  nb-alert.notification(
    v-if="notificationVisible"
    v-bind="notification"
    @close="closeNotification"
  )
    template(#image)
      img(
        v-if="notification.congrats"
        :src="ImagePartyPopper"
      )
  |
  PortalTarget(name="root")
  |
  PortalTarget(name="root-secondary")
  |
  PortalTarget(name="root-tertiary")
  |
  PortalTarget(name="toast")
  |
  PortalTarget(name="form")
  |
  PortalTarget(name="notifications")
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import ImagePartyPopper from "@/assets/images/party-popper_image.svg";

const NOTIFICATION_MODEL = {
  visible: false,
  type: "",
  title: "",
  message: "",
};

const NOTIFICATION_TIMEOUT = 10000;

@Component()
export default class OverlapLayer extends Vue {
  ImagePartyPopper = ImagePartyPopper;
  notification = NOTIFICATION_MODEL;

  get notificationVisible() {
    const { visible, title, message } = this.notification;

    return visible && (title || message);
  }

  closeNotification() {
    this.notification = {};

    this.notification = false;
  }

  showNotification(payload) {
    this.notification = { ...payload, visible: true };

    setTimeout(() => {
      this.closeNotification();
    }, NOTIFICATION_TIMEOUT);
  }

  mounted() {
    this.$root.$on("show-notification", this.showNotification);
  }
}
</script>

<style lang="sass" scoped>
.overlap-wrapper
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 999
  pointer-events: none

  & > *
    pointer-events: all

.notification
  position: absolute !important
  top: 1em
  right: 0
</style>
